<template>
  <div id="stockFlowList">
    <div class="invoicingHead">
      <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a @click="jumpTT('/invoicing/singleStockInquiry')" href="javascript:;"
            >商品库存</a
          >
        </el-breadcrumb-item>
        <el-breadcrumb-item>库存流水</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="searchGroup">
      <div class="singleGoods">
        <div>
          <img v-if="list.goodsImage !== ''" :src="list.goodsImage" class="img" />
          <img
            v-if="list.goodsImage == ''"
            src="@/assets/icon/defaultPic.png"
            class="img"
          />
        </div>
        <div class="flex-column-around pl20">
          <div>{{ list.goodsName }}</div>
          <div class="text-color">规格：{{ list.valueContent }}</div>
          <div class="text-color">
            库存：{{ list.isInfiniteStock == 1 ? "无限库存" : list.qrcTotalStockCount }}
          </div>
          <div class="text-color">仓库：{{ list.repositoryName }}</div>
        </div>
      </div>
      <div class="content">
        <table class="table" width="100%" style="table-layout: fixed">
          <tr class="th">
            <td>
              <div class="flex-row-start">
                <div class="pl20">
                  <el-input
                    v-model="orderCode"
                    style="width: 200px"
                    placeholder="输入单号"
                  ></el-input>
                </div>
                <div class="pl20">
                  <el-button type="primary" @click="search" size="mini">搜索</el-button>
                </div>
                <div class="pl20">
                  <el-select
                    size="small"
                    v-model="synthesisOrderType"
                    style="width: 220px"
                    @change="search"
                  >
                    <el-option
                      v-for="item in synthesisOrderTypeList"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr class="td" v-for="(item, index) in tableData" :key="index">
            <td>
              <span
                >{{ item.orderTypes
                }}<span
                  v-if="
                    item.orderType == 1 ||
                    item.orderType == 2 ||
                    item.orderType == 3 ||
                    item.orderType == 4
                  "
                  >{{ item.orderCode }}</span
                ></span
              >
            </td>
            <td>
              <span class="center" v-if="item.orderType == 6 || item.orderType == 8"
                >商品销售金额：{{ item.productMoney ? item.productMoney : "----" }}</span
              >
              <span class="center" v-else-if="item.orderType == 7 || item.orderType == 9"
                >商品销售退款金额：{{
                  item.productMoney ? item.productMoney : "----"
                }}</span
              >
              <span class="center" v-else
                >经手人：{{ item.handlerName ? item.handlerName : "----" }}</span
              >
            </td>
            <td>
              <div
                :class="
                  item.orderStyle == '无盈亏'
                    ? 'text-color1'
                    : item.orderStyle == '有盈亏'
                    ? 'text-color2'
                    : ''
                "
                style="white-space: normal"
              >
                {{ item.orderStyle }}
              </div>
            </td>
            <td>{{ item.repositoryName }}</td>
            <td>业务日期：{{ item.createTime }}</td>
            <!-- <td>{{item.isDestroy == 1 ? "作废" : ""}}</td> -->
            <td>
              <div
                style="
                  width: 60px;
                  height: 30px;
                  line-height: 30px;
                  border-radius: 10px;
                  border: 1px solid #ccc;
                  margin: auto;
                  color: #ccc;
                  font-size: 10px;
                "
                v-if="item.goodsStatus == '作废'"
              >
                {{ item.goodsStatus }}
              </div>
              <div
                style="
                  width: 60px;
                  height: 30px;
                  line-height: 30px;
                  border-radius: 10px;
                  border: 1px solid #6abcf8;
                  margin: auto;
                  color: #6abcf8;
                  font-size: 10px;
                "
                v-if="item.goodsStatus == '已出库'"
              >
                {{ item.goodsStatus }}
              </div>
              <div
                style="
                  width: 60px;
                  height: 30px;
                  line-height: 30px;
                  border-radius: 10px;
                  border: 1px solid #6abcf8;
                  margin: auto;
                  color: #6abcf8;
                  font-size: 10px;
                "
                v-if="item.goodsStatus == '已入库'"
              >
                {{ item.goodsStatus }}
              </div>
              <div
                style="
                  width: 60px;
                  height: 30px;
                  line-height: 30px;
                  border-radius: 10px;
                  border: 1px solid #ccc;
                  margin: auto;
                  color: #ccc;
                  font-size: 10px;
                "
                v-if="item.goodsStatus == '未入库'"
              >
                {{ item.goodsStatus }}
              </div>
              <div
                style="
                  width: 60px;
                  height: 30px;
                  line-height: 30px;
                  border-radius: 10px;
                  border: 1px solid #ccc;
                  margin: auto;
                  color: #ccc;
                  font-size: 10px;
                "
                v-if="item.goodsStatus == '未出库'"
              >
                {{ item.goodsStatus }}
              </div>
              <div
                style="
                  width: 60px;
                  height: 30px;
                  line-height: 30px;
                  border-radius: 10px;
                  border: 1px solid #ff9e7a;
                  margin: auto;
                  color: #ff9e7a;
                  font-size: 10px;
                "
                v-if="item.goodsStatus == '部分入库'"
              >
                {{ item.goodsStatus }}
              </div>
            </td>
            <td>
              <el-button
                type="primary"
                size="mini"
                plain
                @click="detail(item)"
                v-if="item.orderType !== 5"
                >详情</el-button
              >
            </td>
          </tr>
        </table>
      </div>
      <div
        v-if="tableData.length > 0"
        style="float: right; margin-top: 35px; margin-left: 76%"
      >
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="queryInfo.pageNo"
          :page-size="queryInfo.row"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { repositoryFlowList, repositoryFlowListTotalNum, singleQueryGoods } from "../api";
export default {
  data() {
    return {
      arr: {},
      orderCode: "",
      synthesisOrderType: "",
      synthesisOrderTypeList: [
        { value: "", name: "全部排序" },
        { value: 0, name: "按初期库存" },
        { value: 1, name: "按出库量" },
        { value: 2, name: "按入库量" },
        { value: 3, name: "按待入库量" },
      ],
      tableData: [],
      queryInfo: {
        pageNo: 1,
        row: 10,
      },
      total: 0,
      status: "",
      list: {},
    };
  },
  created() {
    this.arr = JSON.parse(localStorage.getItem("list") || "[]");
    console.log(this.arr);
    this.getSingleQueryGoods();
    this.getRepositoryFlowList();
  },
  methods: {
    //跳转
    jumpTT(adress, message) {
      this.$router.push({ path: adress, query: { docId: message } });
    },
    getSingleQueryGoods() {
      singleQueryGoods({
        isManager: 1,
        pageNo: 1,
        row: 9999,
        repositoryId: this.arr.repositoryId,
        goodsId: this.arr.goodsId,
        productId: this.arr.productId,
      }).then((res) => {
        if (res.code == 1) {
          this.list = res.data;
          if (this.list.isInfiniteStock == 1) {
            this.list.qrcTotalStockCount = "无限库存";
          }
          if (this.list.beginIsInfiniteStock == 1) {
            this.list.beginStockNum = "无限库存";
          }
          if (this.list.beginIsInfiniteStock == 0) {
            if (!this.list.beginStockNum) {
              this.list.beginStockNum = 0;
            }
          }
          localStorage.setItem("list", JSON.stringify(this.list));
        }
      });
    },
    getRepositoryFlowList(orderCode, synthesisOrderType) {
      repositoryFlowList({
        isManager: 1,
        pageNo: this.queryInfo.pageNo,
        row: this.queryInfo.row,
        goodsId: this.arr.goodsId,
        productId: this.arr.productId,
        repositoryId: this.arr.repositoryId,
        orderCode: orderCode,
        synthesisOrderType: synthesisOrderType,
      }).then((res) => {
        if (res.code == 1) {
          this.tableData = res.data; //单号类型 1,盘点单2,进货单3,退货单4,调拨单5,初期库存 6.商品销售
          for (var i in this.tableData) {
            if (this.tableData[i].isDestroy == 1) {
              this.tableData[i].goodsStatus = "已作废";
            }
            if (this.tableData[i].orderType == 1) {
              this.tableData[i].orderTypes = "盘点单：";
              this.tableData[i].orderStyle =
                this.tableData[i].checkStatus == 0 ? "无盈亏" : "有盈亏";
              this.tableData[i].repositoryName =
                "仓库：" + this.tableData[i].repositoryName;
            } else if (this.tableData[i].orderType == 2) {
              this.tableData[i].orderTypes = "入库单：";
              if (this.tableData[i].inputNum) {
                this.tableData[i].orderStyle = "入库量：" + this.tableData[i].inputNum;
              } else {
                this.tableData[i].orderStyle = "入库量：" + 0;
              }
              if (this.tableData[i].inStorageStatus == 0) {
                this.tableData[i].goodsStatus = "未入库";
                // this.tableData[i].goodsStatus = this.tableData[i].inStorageStatus == 0 ? "未入库" : this.tableData[i].inStorageStatus == 1 ? "已入库" : this.tableData[i].inStorageStatus == 2 ? "部分入库" : ""
              } else if (this.tableData[i].inStorageStatus == 1) {
                this.tableData[i].goodsStatus = "已入库";
              } else if (this.tableData[i].inStorageStatus == 2) {
                this.tableData[i].goodsStatus = "部分入库";
              }
              this.tableData[i].repositoryName =
                "仓库：" + this.tableData[i].repositoryName;
            } else if (this.tableData[i].orderType == 3) {
              this.tableData[i].orderTypes = "出库单：";
              if (this.tableData[i].outputNum) {
                this.tableData[i].orderStyle = "出库量：" + this.tableData[i].outputNum;
              } else {
                this.tableData[i].orderStyle = "出库量：" + 0;
              }
              if (this.tableData[i].outStorageStatus) {
                this.tableData[i].goodsStatus =
                  this.tableData[i].outStorageStatus == 1
                    ? "已出库"
                    : this.tableData[i].outStorageStatus == 0
                    ? "未出库"
                    : "";
              }
              this.tableData[i].repositoryName =
                "仓库：" + this.tableData[i].repositoryName;
            } else if (this.tableData[i].orderType == 4) {
              this.tableData[i].orderTypes = "调拨单：";
              if (this.arr.repositoryName == this.tableData[i].repositoryOutName) {
                this.tableData[i].orderStyle = "出库量：" + this.tableData[i].outputNum;
              } else if (this.arr.repositoryName == this.tableData[i].repositoryInName) {
                this.tableData[i].orderStyle = "入库量：" + this.tableData[i].inputNum;
              }
              if (this.tableData[i].inStorageStatus) {
                this.tableData[i].goodsStatus =
                  this.tableData[i].inStorageStatus == 1
                    ? "已入库"
                    : this.tableData[i].inStorageStatus == 0
                    ? "未入库"
                    : this.tableData[i].inStorageStatus == 2
                    ? "部分入库"
                    : "";
              }
              this.tableData[i].repositoryName =
                this.tableData[i].repositoryOutName +
                " " +
                "至" +
                " " +
                this.tableData[i].repositoryInName;
            } else if (this.tableData[i].orderType == 5) {
              this.tableData[i].orderTypes = "初期库存";
              if (this.tableData[i].isInfiniteStock == 1) {
                this.tableData[i].beginStockNum = "无限库存";
              }
              if (this.tableData[i].isInfiniteStock == 0) {
                if (!this.tableData[i].beginStockNum) {
                  this.tableData[i].beginStockNum = 0;
                }
              }
              this.tableData[i].orderStyle =
                "初期库存：" + this.tableData[i].beginStockNum;
              this.tableData[i].repositoryName =
                "仓库：" + this.tableData[i].repositoryName;
            } else if (
              this.tableData[i].orderType == 6 ||
              this.tableData[i].orderType == 8
            ) {
              this.tableData[i].orderTypes =
                this.tableData[i].orderType == 8 ? "线上商品销售" : "商品销售";
              if (this.tableData[i].productNum) {
                this.tableData[i].orderStyle =
                  "商品销售数量：" + this.tableData[i].productNum;
              } else {
                this.tableData[i].orderStyle =
                  "商品销售金额：" + this.tableData[i].productMoney;
              }
              this.tableData[i].repositoryName =
                "仓库：" + this.tableData[i].repositoryName;
            } else if (
              this.tableData[i].orderType == 7 ||
              this.tableData[i].orderType == 9
            ) {
              this.tableData[i].orderTypes =
                this.tableData[i].orderType == 9 ? "线上商品销售退货" : "商品销售退货";
              if (this.tableData[i].inputNum) {
                this.tableData[i].orderStyle =
                  "商品销售退货数量：" + this.tableData[i].inputNum;
              } else {
                this.tableData[i].orderStyle =
                  "商品销售退货金额：" + this.tableData[i].productMoney;
              }
              this.tableData[i].repositoryName =
                "仓库：" + this.tableData[i].repositoryName;
            }
          }
          repositoryFlowListTotalNum({
            isManager: 1,
            pageNo: this.queryInfo.pageNo,
            row: this.queryInfo.row,
            goodsId: this.arr.goodsId,
            productId: this.arr.productId,
            repositoryId: this.arr.repositoryId,
            orderCode: orderCode,
            synthesisOrderType: synthesisOrderType,
          }).then((res) => {
            if (res.code == 1) {
              this.total = res.data.totalNum;
            }
          });
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleSizeChange(val) {
      this.queryInfo.row = val;
      this.getRepositoryFlowList();
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      if (this.status == 1) {
        this.getRepositoryFlowList(this.orderCode.trim(), this.synthesisOrderType);
      } else {
        this.getRepositoryFlowList();
      }
    },
    search() {
      this.status = 1;
      this.queryInfo.pageNo = 1;
      this.getRepositoryFlowList(this.orderCode.trim(), this.synthesisOrderType);
    },
    detail(item) {
      console.log(item);
      if (item.orderType == 5) {
        this.$message.warning("该商品没有详情信息");
      } else if (item.orderType == 2) {
        this.$router.push("/invoicing/stockFlowDetail");
        localStorage.setItem("detail", JSON.stringify(item));
      } else if (item.orderType == 3) {
        this.$router.push("/invoicing/stockFlowReturnDetail");
        localStorage.setItem("detail", JSON.stringify(item));
      } else if (item.orderType == 1) {
        this.$router.push("/invoicing/stockFlowInventoryDetail");
        localStorage.setItem("detail", JSON.stringify(item));
      } else if (item.orderType == 4) {
        this.$router.push("/invoicing/stockFlowTransferDetail");
        localStorage.setItem("detail", JSON.stringify(item));
      } else if (item.orderType == 6 || item.orderType == 7) {
        this.$router.push({
          path: "/order/offline",
          query: {
            goodsId: item.goodsId,
            orderDate: item.createTime,
            productId: item.productId,
          },
        });
      } else if (item.orderType == 8 || item.orderType == 9) {
        this.$router.push({
          path: "/order",
          query: {
            createTime: item.createTime,
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.text-color1 {
  width: 60px;
  height: 30px;
  line-height: 30px;
  border-radius: 10px;
  border: 1px solid #ff9e7a;
  margin: auto;
  color: #ff9e7a;
  font-size: 10px;
}
.text-color2 {
  width: 60px;
  height: 30px;
  line-height: 30px;
  border-radius: 10px;
  border: 1px solid #ccc;
  margin: auto;
  color: #ccc;
  font-size: 10px;
}
.searchGroup {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 20px;
}
.singleGoods {
  width: 100%;
  height: 200px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.content {
  width: 100%;
  max-height: 580px;
  overflow-y: scroll;
  color: #606266;
  font-size: 14px;
}
table {
  border: 0;
  border-collapse: 0;
  border-spacing: 0;
  font-size: 14px;
}
.table {
  width: 100%;
  font-size: 12px;
}
.th {
  background: #f8f8f8;
  padding: 15px;
  height: 40px;
  font-size: 14px;
  color: #909399;
  font-weight: 600;
}
.td td {
  height: 55px;
  border-bottom: 1px solid #ebeef5;
  text-align: center;
  word-break: keep-all; /* 不换行 */
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用*/
}
.th td {
  font-size: 14px;
  border-bottom: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
  text-align: center;
  height: 50px;
}
td {
  font-size: 14px;
  padding: 0;
  margin: 0;
}
.flex-row-start {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
}
.flex-column-around {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.img {
  width: 185px;
  height: 175px;
  border-radius: 5px;
}
.pl20 {
  padding-left: 20px;
  box-sizing: border-box;
}
::v-deep .el-input__inner {
  height: 32px;
  line-height: 32px;
}
</style>
<style></style>
